module.exports = __webpack_public_path__ + "static/img/pvc film_page bottom_mobile.9d2fd1f7.jpg";